<template>
  <div class="m-l-50 m-t-30 w-500">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="规则名称" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="规则标识" prop="name">
        <el-input v-model.trim="form.name" class="h-40 w-200"></el-input>
      </el-form-item>
      <!-- <el-form-item label="节点类型" prop="level">
        <el-radio-group v-model="form.level">
          <el-radio label="1">模块</el-radio>
          <el-radio label="2">控制器</el-radio>
          <el-radio label="3">操作</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="父节点" prop="pid">
        <el-select v-model="form.pid" placeholder="父节点" class="w-200">
          <el-option v-for="item in options" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add('form')" :loading="isLoading">提交</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import _verify from '../../../../assets/js/verify'

  export default {
    data() {
      return {
        isLoading: false,
        form: {
          title: '',
          name: '',
          pid: null,
          level: '1'
        },
        options: [{ id: 0, name: '根节点' }],
        rules: {
          title: [
            { required: true, message: '请输入规则名称' }
          ],
          name: [
            { required: true, message: '请输入规则标识' },
            { validator: this.isEngAndNum, trigger: 'blur' }
          ],
          // level: [
          //   { required: true, message: '请选择节点类型' }
          // ],
          pid: [
            { type: 'number', required: true, message: '请选择父级节点' }
          ]
        }
      }
    },
    methods: {
      add(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/rules', this.form).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '添加成功')
                _g.clearVuex('setRules')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      getRules() {
        this.apiGet('admin/rules').then((res) => {
          if (res.code == 200) {
            _(res.data).forEach((res) => {
              if (res.level != 3) {
                this.options.push(res)
              }
            })
          } else {
            _g.dealError(this, res)
          }
        })
      },
      isEngAndNum(rule, value, callback) {
        if (!_verify.isEngAndNum(value)) {
          callback(new Error('仅支持输入英文、数字、_下划线'))
        } else {
          callback()
        }
      },
      goback() {
        router.go(-1)
      }
    },
    created() {
      this.getRules()
    },
    components: {
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?8b20491c